import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import viewAllImg from "../assets/viewall.jpg";

const LifeAtSchool = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    Promise.all([
      fetch("https://deoria.ilakshyaerp.in/api/academics").then(res => res.json()),
      fetch("https://deoria.ilakshyaerp.in/api/galleryAwards").then(res => res.json()),
      fetch("https://deoria.ilakshyaerp.in/api/birthday").then(res => res.json()),
      fetch("https://deoria.ilakshyaerp.in/api/student").then(res => res.json()),
    ])
      .then(([academics, galleryAwards, birthday, student]) => {
        setData([
          {
            title: "Academics",
            img: academics?.[0]?.image
              ? `https://deoria.ilakshyaerp.in/uploads/academics/${academics[0].image}`
              : "https://picsum.photos/400/400?1",
            desc: "Strong academic foundation with modern learning.",
            link: "/life?type=academics",
          },
          {
            title: "Gallery & Awards",
            img: galleryAwards?.[0]?.image
              ? `https://deoria.ilakshyaerp.in/uploads/galleryAwards/${galleryAwards[0].image}`
              : "https://picsum.photos/400/400?2",
            desc: "Explore school memories and moments.",
            link: "/life?type=galleryAwards",
          },
          {
            title: "Birthday",
            img: birthday?.[0]?.image
              ? `https://deoria.ilakshyaerp.in/uploads/birthday/${birthday[0].image}`
              : "https://picsum.photos/400/400?3",
            desc: "Celebrating students birthdays.",
            link: "/life?type=birthday",
          },
          {
            title: "Student Work",
            img: student?.[0]?.image
              ? `https://deoria.ilakshyaerp.in/uploads/student/${student[0].image}`
              : "https://picsum.photos/400/400?4",
            desc: "Creative and academic student work.",
            link: "/life?type=student",
          },
          {
            title: "View All",
            img: viewAllImg,
            desc: "Explore all school life activities.",
            link: "/life?type=all",
          },
        ]);
      })
      .catch(() => console.log("Life section fetch error"));
  }, []);

  return (
    <section className="life-section">
      <div className="life-page" >
        <h3>
        LIFE AT SCHOOL
      </h3>
      <p>
        See some of the major things of the school
      </p>
      </div>
      

      <div className="life-grid">

        {data.map((item, i) => (
          <div
            key={i}
            className="life-card"
            onClick={() => navigate(item.link)}
          >
            <img
              src={item.img}
              alt={item.title}
            />

            <div className="circle-overlay">

              <h3>{item.title}</h3>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(item.link);
                }}
              >
                Show
              </button>

            </div>

          </div>
        ))}

      </div>

    </section>
  );
};

export default LifeAtSchool;